<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <AddNewWSU title="กรุณากรอกข้อมูล"></AddNewWSU>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AddNewWSU from "./AddNewWSU";

export default {
  name: "customerWsuExtend",
  components: {
    AddNewWSU,
  },
};
</script>
<style scoped></style>
